import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import Drip from '@/drip';
import KNB from '@dp/knb';
var getSSLInfoMethod = function getSSLInfoMethod() {
  if (Drip.UA.IS_MAOYAN) {
    return 'movie.getCertificateInfo';
  } else if (Drip.UA.IS_MEITUAN || Drip.UA.IS_DIANPING) {
    return 'movie.getMtCertificateInfo';
  } else {
    return 'movie.getCertificateInfo';
  }
};
export var getSSLCA = function getSSLCA() {
  return new Promise(function (resolve, reject) {
    try {
      var responseByKnb = function responseByKnb() {
        return {
          success: function success(response) {
            resolve(response ? response.certificate : '');
          },
          fail: function fail(error) {
            resolve('');
          }
        };
      };
      var method = getSSLInfoMethod();
      KNB.use("".concat(method), Object.assign({
        host: location.host
      }, responseByKnb()));
      setTimeout(function () {
        resolve('');
      }, 300);
    } catch (err) {
      resolve('');
    }
  });
};
export var canGetSSLInfo = function canGetSSLInfo() {
  if (Drip.UA.IS_MAOYAN) {
    return true;
  } else if (Drip.UA.IS_MEITUAN && KNB.Semver.gte(Drip.UA.appVersion, '12.29.400')) {
    return true;
  } else if (Drip.UA.IS_DIANPING && Drip.UA.osName === 'ios' && KNB.Semver.gte(Drip.UA.appVersion, '11.42.3')) {
    return true;
  } else {
    return false;
  }
};
export var needFetchWebviewConfig = function needFetchWebviewConfig() {
  if (Drip.UA.IS_MEITUAN) {
    return KNB.Semver.gte(Drip.UA.appVersion, '12.29.400');
  } else if (Drip.UA.IS_DIANPING && Drip.UA.osName === 'ios') {
    return KNB.Semver.gte(Drip.UA.appVersion, '11.42.3');
  } else {
    return false;
  }
};